<template>
  <v-card border>
    <v-card-text class="py-4">
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center ga-3">
          <v-btn
            :icon="isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
            color="grey-lighten-4"
            max-height="28px"
            max-width="28px"
            density="comfortable"
            @click="isExpanded = !isExpanded"></v-btn>

          <b>{{ flaw.text }}</b>

          <div>
            <div v-if="flaw.risks?.length" class="d-flex flex-wrap ga-2">
              <v-chip
                v-for="risk in flaw.risks"
                :key="risk.id"
                border
                class="bg-white"
                closable
                density="compact"
                rounded="pill"
                variant="flat"
                @click:close="deleteRisk(flaw.id, risk.id)">
                <div class="d-flex align-center ga-1">
                  <v-icon
                    :color="riskColors[risk.riskLevel.id]"
                    icon="mdi-circle"
                    size="small" />
                  <span>
                    {{ risk.riskType.name }} - {{ risk.riskLevel.name }}
                  </span>
                </div>
              </v-chip>
            </div>
            <span v-else class="text-disabled"> Ризики не вказано </span>
          </div>
        </div>

        <div class="d-flex ga-2">
          <v-btn border color="white" @click="createRisk(flaw.id)">
            <v-icon class="mr-1" color="black" icon="mdi-plus"> </v-icon>
            <span class="text-black font-weight-medium">Ризик</span>
          </v-btn>

          <v-btn
            v-tooltip="'Редагувати факт ризику'"
            border
            color="white"
            @click="updateFlaw(flaw.id)">
            <span class="text-black font-weight-medium">Ред.</span>
          </v-btn>

          <v-btn
            v-tooltip="'Видалити факт ризику'"
            :loading="$loading.isLoading(`deleteFlaw_${flaw.id}`)"
            border
            class="border-error border-opacity-50"
            color="white"
            icon
            max-height="40px"
            max-width="40px"
            size="small"
            @click="deleteFlaw(flaw.id)">
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card-text>
    <transition name="expand">
      <div v-if="isExpanded">
        <v-divider></v-divider>

        <v-card-text>
          <div
            class="font-weight-bold text-uppercase text-grey font-size-12 mb-2">
            Опис недоліку
          </div>
          <div class="mb-2">{{ flaw.factorFlaw }}</div>
          <div class="text-disabled font-size-13">
            Зафіксовано: {{ new CustomDate(flaw.created_at).toString() }}
          </div>

          <v-divider class="my-2"></v-divider>

          <div v-if="flaw.recommendations?.length">
            <div
              class="font-weight-bold text-uppercase text-grey font-size-12 mb-2">
              Рекомендації щодо усунення
            </div>

            <recommendation-list
              :flaw-id="flaw.id"
              :recommendations="flaw.recommendations"
              class="mb-3"></recommendation-list>

            <v-btn border color="white" @click="createRecommendation(flaw.id)">
              <v-icon class="mr-1" color="black" icon="mdi-plus"></v-icon>
              <span class="text-black font-weight-medium">
                Додати рекомендацію
              </span>
            </v-btn>
          </div>
          <div v-else class="d-flex justify-space-between align-center">
            <div class="text-disabled font-si">Рекомендацій ще не додано</div>
            <v-btn border color="white" @click="createRecommendation(flaw.id)">
              <v-icon class="mr-1" color="black" icon="mdi-plus"></v-icon>
              <span class="text-black font-weight-medium">
                Додати рекомендацію
              </span>
            </v-btn>
          </div>
        </v-card-text>
      </div>
    </transition>
  </v-card>
</template>

<script lang="ts">
import { useAudit } from '../../index'
import { AuditFlaw } from '@/utils/types/audit'
import { PropType, ref } from 'vue'
import { CustomDate } from 'best-modules/utils'
import RecommendationList from './RecommendationList.vue'

export default {
  name: 'FlawItem',
  components: { RecommendationList },
  props: {
    flaw: {
      type: Object as PropType<AuditFlaw>,
      required: true,
    },
    index: {
      type: Number,
    },
  },
  methods: { CustomDate },
  setup(props) {
    const riskColors: Record<number, string> = {
      1: 'green',
      2: 'light-green',
      3: 'orange',
      4: 'red',
    }
    const {
      audit,
      updateFlaw,
      deleteFlaw,
      createRisk,
      deleteRisk,
      createRecommendation,
    } = useAudit()

    const isExpanded = ref<boolean>(props.index === 0)

    return {
      isExpanded,
      audit,
      riskColors,
      updateFlaw,
      deleteFlaw,
      createRisk,
      deleteRisk,
      createRecommendation,
    }
  },
}
</script>

<style lang="scss" scoped></style>
